import 'core-js/stable'
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import AppLayout from 'theme/layout/layout.vue'
import AppConfig from 'src/app.config'
import store from 'src/vuex/store'
import router from 'src/router/index'
import { sync } from 'vuex-router-sync'
import logService from 'src/services/log.service'
import dataService from 'src/app.service'
import featureFlags from 'src/services/featureFlags.service'
import userService from 'src/services/user.service.cookies'
import StoryblokVue from 'storyblok-vue'
import VueAnalytics from 'vue-analytics'
import VueGtag from "vue-gtag"
import VueMeta from 'vue-meta'
import VueClipboards from 'vue-clipboards'
import * as VueGoogleMaps from 'vue2-google-maps'
import 'lazysizes'
import packageJson from '../package.json'

import blokGrid from 'theme/components/blok/blok-grid.vue'
import blokColumn from 'theme/components/blok/blok-column.vue'
import blokImage from 'theme/components/blok/blok-image.vue'
import blokButton from 'theme/components/blok/blok-button.vue'
import blokDownloadButton from 'theme/components/blok/blok-download-button.vue'
import blokText from 'theme/components/blok/blok-text.vue'
import blokTable from 'theme/components/blok/blok-table.vue'
import blokTitle from 'theme/components/blok/blok-title.vue'
import blokHtml from 'theme/components/blok/blok-html.vue'
import blokDate from 'theme/components/blok/blok-date.vue'
import blokConversion from 'theme/components/blok/blok-conversion.vue'

Vue.component('blokGrid', blokGrid)
Vue.component('blokColumn', blokColumn)
Vue.component('blokImage', blokImage)
Vue.component('blokButton', blokButton)
Vue.component('blokDownloadButton', blokDownloadButton)
Vue.component('blokText', blokText)
Vue.component('blokTable', blokTable)
Vue.component('blokTitle', blokTitle)
Vue.component('blokHtml', blokHtml)
Vue.component('blokDate', blokDate)
Vue.component('blokConversion', blokConversion)

if (process.env.TARGET_ENV !== 'production') {
  Vue.config.devtools = true
}

var isBrowser = typeof window !== 'undefined'

if (isBrowser) {
  window.eventBus = new Vue()
}

featureFlags.setDefaultFlags()

Vue.use(logService)
Vue.use(StoryblokVue)
Vue.use(VeeValidate)
Vue.use(VueMeta)
Vue.use(VueClipboards)
Vue.use(VueAnalytics, {
  id: AppConfig.trackingGA,
  router,
  ecommerce: {
    enabled: true,
    enhanced: true,
  },
  set: [
    {
      field: 'dimension18',
      value: userService.isAnalyticsAsInternalUser() ? 'internal' : '',
    },
  ],
})
Vue.use(VueGtag, {
  config: { id: AppConfig.ga4Tag, }
}, router)
Vue.use(VueGoogleMaps, {
  load: {
    key: AppConfig.googleMapsKey,
    libraries: 'places',
  },
  installComponents: true,
})

Vue.directive('focus', {
  inserted(el, binding, vnode) {
    Vue.nextTick(() => {
      if (!binding.hasOwnProperty('value') || binding.value) {
        el.focus()
      }
    })
  },
})

sync(store, router)
store.$http = dataService

const app = new Vue({
  router,
  store,
  ...AppLayout,
})

export { app, router, store }
